import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, Check } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function CTASection() {
  return <section className="pt-10 pb-10 bg-white relative overflow-hidden" data-id="element-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-33">
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-orange-600 via-violet-600 to-emerald-500 rounded-3xl p-8 md:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-34">
          {/* Decorative circles */}
          <div className="absolute top-0 left-0 -mt-10 -ml-10 w-40 h-40 bg-orange-500 rounded-full opacity-60" data-id="element-35"></div>
          <div className="absolute bottom-0 right-0 -mb-10 -mr-10 w-40 h-40 bg-emerald-600 rounded-full opacity-50" data-id="element-36"></div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative z-10" data-id="element-37">
            <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6" data-id="element-38">
              <span className="inline-block bg-gradient-to-r from-yellow-300 to-orange-400 text-gray-900 px-4 py-1 rounded-xl mb-3 text-2xl md:text-3xl" data-id="element-39">
                🔥 ¡Aprovechá el 50% OFF y los 5 bonos de regalo!
              </span>
              <br data-id="element-40" />
              Dejá atrás las peleas a la hora de comer
            </h2>

            <p className="text-xl text-orange-50 mb-10 max-w-2xl mx-auto" data-id="element-41">
              Con "Recetas Rápidas para Niños que Odian las Verduras" vas a
              lograr que tus hijos coman de forma sana y nutritiva. Descargalo
              hoy y convertí las comidas en momentos para disfrutar.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8" data-id="element-42">
              <motion.button onClick={() => {
              const el = document.getElementById('comprar-ahora');
              if (el) el.scrollIntoView({
                behavior: 'smooth'
              });
            }} whileHover={{
              scale: 1.07,
              boxShadow: '0 0 40px rgba(251,191,36,0.7)'
            }} whileTap={{
              scale: 0.96
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 18
            }} className="w-full sm:w-auto bg-gradient-to-r from-yellow-400 to-orange-400 hover:from-yellow-300 hover:to-orange-300 text-gray-900 font-extrabold text-xl px-14 py-5 rounded-full shadow-2xl cursor-pointer flex items-center justify-center gap-3 border-4 border-yellow-200" data-id="element-43">
                🛒 ¡DESCARGAR EBOOK AHORA!
                <ArrowRight className="h-6 w-6" data-id="element-44" />
              </motion.button>
            </div>

            <p className="text-lg font-extrabold text-white" data-id="element-45">
              🔥 Antes{' '}
              <span className="line-through text-white/50" data-id="element-46">$29.900</span> — Hoy{' '}
              <span className="text-yellow-300" data-id="element-47">$14.900</span>
            </p>
            <p className="text-sm font-semibold text-orange-100" data-id="element-48">
              📩 Acceso inmediato al eBook después del pago, se envía a tu
              correo electrónico
            </p>

            {/* Trust block */}
            <div className="bg-orange-50 border border-orange-200 rounded-2xl p-4 mb-6 flex flex-col sm:flex-row items-center gap-4 text-left shadow-lg" data-id="element-49">
              {/* Guarantee badge + text */}
              <div className="flex items-center gap-3 flex-1" data-id="element-50">
                <img src="https://cdn.magicpatterns.com/uploads/r8nSn2xyyAgjWmwb7YDRb6/pngtree-100-satisfaction-guaranteed-gold-badge-seal-png-image_20957525.png" alt="Garantía 100%" className="w-16 h-16 object-contain flex-shrink-0" data-id="element-51" />
                <div data-id="element-52">
                  <p className="font-extrabold text-gray-900 text-sm leading-snug" data-id="element-53">
                    GARANTÍA DE{' '}
                    <span className="text-orange-500" data-id="element-54">60 DÍAS:</span>{' '}
                    <span className="italic" data-id="element-55">"BIENESTAR TOTAL"</span>
                  </p>
                  <p className="text-gray-600 text-xs mt-1 leading-relaxed" data-id="element-56">
                    Si en 60 días no ves mejorías, te{' '}
                    <strong data-id="element-57">devolvemos el 100% del dinero</strong>. Sin
                    preguntas.
                  </p>
                </div>
              </div>

              {/* Divider */}
              <div className="hidden sm:block w-px h-20 bg-orange-200" data-id="element-58" />

              {/* Mercado Pago */}
              <div className="flex-shrink-0 flex items-center justify-center" data-id="element-59">
                <img src="https://cdn.magicpatterns.com/uploads/exnF17cDNEq91LXz1fKfr9/Imagen_21-2-26_a_las_4.23_p._m._(1).jpg" alt="Mercado Pago - medios de pago" className="h-24 w-auto object-contain" data-id="element-60" />
              </div>
            </div>

            {/* Stars */}
            <div className="flex items-center justify-center gap-2 mb-6" data-id="element-61">
              {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-400 text-xl" data-id="element-62">
                  ★
                </span>)}
              <span className="text-orange-100 text-sm font-semibold ml-1" data-id="element-63">
                4.9/5 opiniones verificadas
              </span>
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-orange-100 text-sm font-medium" data-id="element-64">
              <div className="flex items-center gap-2 bg-white/10 rounded-full px-4 py-2" data-id="element-65">
                <span className="text-lg" data-id="element-66">⚡</span>
                Acceso Inmediato
              </div>
              <div className="flex items-center gap-2 bg-white/10 rounded-full px-4 py-2" data-id="element-67">
                <span className="text-lg" data-id="element-68">🔒</span>
                Pago Seguro
              </div>
              <div className="flex items-center gap-2 bg-white/10 rounded-full px-4 py-2" data-id="element-69">
                <span className="text-lg" data-id="element-70">🏅</span>
                Garantía de Satisfacción
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}